import { Resource } from "./../../models/resource";

export class Reason extends Resource {
  reasonId: string | null | undefined;
  reasonName: string | null | undefined;
  reasonRates: number[] | null | undefined;
}
